"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var toPromise = function (sync) {
    return new Promise(function (resolve, reject) {
        var disposer = mobx_1.autorun(function () {
            if (!sync.syncing && sync.hasSynced) {
                disposer();
                if (sync.error) {
                    reject(sync.error);
                }
                else {
                    resolve();
                }
            }
        });
    });
};
exports.toPromise = toPromise;
